import React from "react";
import MainPage from "./page/MainPage";

function App() {
  return (
    <div className="App">
      <p className="bg-black min-h-screen text-white flex items-start justify-center text-2xl">
        <MainPage />
      </p>
    </div>
  );
}

export default App;
